export default __webpack_public_path__ + "static/media/B695.220cc954.webp";